import { Component, OnInit } from '@angular/core';
import { PortService } from 'src/app/core-services/port.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { openLoginModal } from 'src/app/core-services/eventEmitter';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent implements OnInit {
  shippinglineslist: any = [];
  vesselslist: any = [];
  voyagelist: any = [];
  vesselslistData: any = [];
  voyagelistData: any = [];
  stateParams: any;
  shippingLine: any;
  isShown: boolean = false;
  shipId: number = 0;
  vesselId: number = 0;
  voyageId: number = 0;
  fromPortId: number = 0;
  toPortId: number = 0
  userId: number = 0;
  fromDate: string = '';
  trackingData: any = [];
  fromPortData: any;
  toPortData: any;
  trackingNumber: string = '';
  vesselsname: string = '';
  deptPortname: string = '';
  arrPortName: string = '';
  shippingLineName: string = '';
  shippingLineId: string = '';
  ExpectedDeparture: string = '';
  ExpectedArrival: string = '';
  toPlanArrivalDate: string = '';
  fromPlanArrivalDate: string = '';
  currentLocation: string = '';
  nextPortName: string = '';
  nextPortETA: Date;
  currentStatus: string = '';
  isFound: boolean = false;
  trackNumber: string = '';
  proBarDefaultValue: number = 100;
  proBarActualValue: number = 0;
  proBarRemainingValue: number = 0;
  positionCount: number = 0;
  loggedInUser: any;
  lastPortCode: string = '';
  isReadonly: boolean = false;
  ata: Date;
  atd: Date;
  nextPortCode: string = '';
  etaCalc: Date;
  travelDistanceNm: number = 0;
  travelTimeH: number = 0;
  latitude: number = 0;
  longitude: number = 0;
  // latitude: number = 40.047502;
  // longitude: number = -30.154987;
  zoom: number = 6;
  // iconUrl = '/../../../assets/images/sea-ship-with-containers-35.png';
  //iconUrl = '/../../../assets/images/roro-ship-icon-70.png';
  iconUrl = '/../../../assets/images/roro-ship-icon-60.png';

  locationStr: string = '';
  navStatus: string = '';
  speed: string = '';
  destination: string;
  draught: number = 0;
  VoyageEta: Date;
  progressData: number = 0;
  trackingId: number = 0;
  delayed: number = 0;
  isViewPage: boolean = false;
  isSource: boolean = false;
  progressValues: number = 98;
  MMSINumber: string = '';
  windowUrl: string = window.location.href;
  trackingForm = this.fb.group({
    shippingLine: ['', Validators.required],
    vessel: ['', Validators.required],
    Voyage: ['', Validators.required]
  });
  marker:any;
  markerOptions: google.maps.MarkerOptions = {
  icon: {
    url: "../../../assets/images/roro-ship-icon-60.png",
    scaledSize: new google.maps.Size(30, 20)
  }
};

  constructor(private fb: FormBuilder, private portService: PortService, private activatedRoute: ActivatedRoute, private router: Router, private spinner: NgxSpinnerService, private toastr: ToastrService) {
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.stateParams = params.params;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });

    var currentUser = localStorage.getItem('currentUser');
    if (currentUser != null && currentUser != undefined) {
      this.loggedInUser = JSON.parse(currentUser);
      if (this.loggedInUser != null && this.loggedInUser.usersDetailsVM != null) {
        this.userId = this.loggedInUser.usersDetailsVM.id;
      }
    }
  }

  ngOnInit() {
    this.isShown = false;
    this.trackNumber = this.stateParams.trackNumber;

    if (this.trackNumber) {
      this.isViewPage = true;
      this.trackNumber = this.stateParams.trackNumber;
      this.getTrackingDetailsByTrackingNumber();
    } else {
      if (this.stateParams != null && this.stateParams != undefined && this.stateParams.shipId > 0 && this.stateParams.vesselsId > 0 && this.stateParams.fromPortId > 0 && this.stateParams.toPortId > 0 && this.stateParams.deptDate != null && this.stateParams.deptDate != '') {

        this.isShown = true;
        this.isReadonly = true;
        this.shipId = parseInt(this.stateParams.shipId);
        this.vesselId = parseInt(this.stateParams.vesselsId);
        this.fromPortId = parseInt(this.stateParams.fromPortId),
          this.toPortId = parseInt(this.stateParams.toPortId),
          this.fromDate = this.stateParams.deptDate;
        this.getshippingline(this.shipId);
        this.saveTrackData();
        
      }
    }
    this.getVessels();
  }

  getshippingline(shippinglineId) {
    
    this.portService.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippinglineslist = response.content;
          var shipsData = this.shippinglineslist.filter(x => x.shippingLineId == shippinglineId);
          if (shipsData != null && shipsData.length > 0) {
            this.trackingForm.controls.shippingLine.setValue(shipsData[0]);
            this.shippingLineName = shipsData[0].shippingLineName;
          }
      }
      else {
        this.shippinglineslist = null;
      }
    });
  }

  getVessels() {
    this.portService.GetvoyageandvesselsList().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.voyagelist = response.content.voyages;
        this.vesselslist = response.content.vessels;
        this.vesselslistData = response.content.vessels;
        this.voyagelistData = response.content.voyages;

        if (this.stateParams != null && this.stateParams.vesselsId > 0) {
          var vesseslData = this.vesselslist.filter(x => x.id == this.stateParams.vesselsId);
          if (vesseslData != null && vesseslData.length > 0) {
            this.trackingForm.controls.vessel.setValue(vesseslData[0]);
            this.vesselsname = vesseslData[0].vesselsName;
          }
        }
      } else {
        this.voyagelist = null;
        this.vesselslist = null;
        this.vesselslistData = null;
        this.voyagelistData = null;
      }
    });
  }

  getVesselsbyShipsId(event) {
    if (event != null && event.value != null) {
      var shipsId = event.value.shippingLineId > 0 ? event.value.shippingLineId : 0;
      if (shipsId > 0) {
        this.portService.GetVesselsByShippingLineId(shipsId).subscribe((response: any) => {
          if (response != null && response.content != null) {
            this.vesselslist = response.content;
          } else {
            this.vesselslist = null;
          }
        });
      }
      else {
        this.vesselslist = this.vesselslistData;
      }
    }
  }

  getTrackingDetailsByTrackingNumber() {
    if (this.trackNumber != null && this.trackNumber != undefined && this.trackNumber != '') {
      this.spinner.show();
      this.portService.getTrackingDetailsByTrackingNumber(this.trackNumber).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.spinner.hide();
          this.getshippingline(response.content.shippingLineId);
          if (response.content.noOfDays != null) {
            if (response.content.noOfDays > 0) {
              this.delayed = response.content.noOfDays;
            }
            else {
              this.delayed = response.content.noOfDays;
            }
          }
          if (response.content.voyageRoutesData != null && response.content.voyageRoutesData.length > 0) {
            this.isFound = true;
            this.proBarActualValue = response.content.voyageRoutesData.length;
            if (this.proBarActualValue < 10) {
              if (this.proBarActualValue <= 4) {
                this.progressValues = 215;
              }
              else if (this.proBarActualValue < 10 && this.proBarActualValue >= 5) {
                this.progressValues = 175;
              }
              else if (this.proBarActualValue > 15) {
                this.progressValues = 90;
              }
            }
            if (response.content.vesselsData != null && response.content.vesselsData.data.dep_port != null) {
              var count = 1;
              this.lastPortCode = response.content.vesselsData.data.dep_port_unlocode;
              //this.ata = response.content.vesselsData.last_port.ata;
              this.atd = response.content.vesselsData.data.atd_UTC;
              response.content.voyageRoutesData.forEach(element => {
                if (element != null) {
                  element.fromActualArrivalDate = element.fromActualArrivalDate != null ? this.dateConvert(element.fromActualArrivalDate) : null;
                  element.fromActualDepartureDate = element.fromActualDepartureDate != null ? this.dateConvert(element.fromActualDepartureDate) : null;
                  element.fromPlanArrivalDate = element.fromPlanArrivalDate != null ? this.dateConvert(element.fromPlanArrivalDate) : null;
                  element.toActualArrivalDate = element.toActualArrivalDate != null ? this.dateConvert(element.toActualArrivalDate) : null;
                  element.toPlanArrivalDate = element.toPlanArrivalDate != null ? this.dateConvert(element.toPlanArrivalDate) : null;
                  element.toActualDepartureDate = element.toActualDepartureDate != null ? this.dateConvert(element.toActualDepartureDate) : null;

                  if (count == this.proBarActualValue) {
                    if (response.content.vesselsData != null && response.content.vesselsData.data.dest_port) {
                      var portCode = (element.toPortCode != null && element.toPortCode != '') ? element.toPortCode.replace(/\s/g, "") : '';
                      var vesselsPortCode = response.content.vesselsData.data.dest_port_unlocode.replace(/\s/g, "");
                      if (vesselsPortCode == portCode) {
                        var etaDate = this.dateConvert(response.content.vesselsData.data.eta_UTC);
                        if (etaDate == element.toPlanArrivalDate) {
                          this.delayed = 0;
                          element.toActualArrivalDate = response.content.vesselsData.data.eta_UTC != null ? this.dateConvert(response.content.vesselsData.data.eta_UTC) : null;
                        }
                        else {
                          element.toActualArrivalDate = response.content.vesselsData.data.eta_UTC != null ? this.dateConvert(response.content.vesselsData.data.eta_UTC) : null;
                        }
                      }
                    }
                  }

                  if (count == 1) {
                    var portCode = element.fromPortCode.replace(/\s/g, "");
                    if (portCode == response.content.vesselsData.data.dep_port_unlocode) {
                      this.positionCount = count;
                    }
                  }
                  var portCode = element.toPortCode.replace(/\s/g, "");
                  if (portCode == response.content.vesselsData.data.dep_port_unlocode) {
                    this.positionCount = count;
                  }
                  else {
                    var nextPortCode = response.content.vesselsData.data.destination.replace(/\s/g, "");
                    if (portCode == nextPortCode || nextPortCode.includes(portCode)) {
                      this.positionCount = count;
                      this.positionCount = this.positionCount - 1;
                    }
                    else {
                      if (element.isNextPort == true) {
                        this.positionCount = count;
                        this.positionCount = this.positionCount - 1;
                      }
                    }
                  }
                  count = count + 1;
                }
              });
              this.ExpectedArrival = response.content.voyageRoutesData[this.proBarActualValue - 1].toActualArrivalDate;
              this.isSource = response.content.voyageRoutesData[0].portDepartureStatus;
            }
            if (this.isSource == true) {
              this.positionCount = 0;
            }
            var values = 100 / this.proBarActualValue;
            this.progressData = values * this.positionCount;
            var values1 = 100 % this.proBarActualValue;
            if (values1 > 0) {
              var progressNum = this.progressData.toFixed(2);
              this.progressData = parseFloat(progressNum);
            }
            if (this.voyageId > 0) {
              var length = response.content.voyageRoutesData.length;
              var fromPortData = response.content.voyageRoutesData[0];
              var toPortData = response.content.voyageRoutesData[length - 1];

              if (fromPortData != null && toPortData != null) {
                var trackData = response.content.voyageRoutesData.filter(x => x.toPortId != fromPortData.toPortId);
                if (trackData != null && trackData.length > 0) {
                  this.trackingData = trackData.filter(x => x.toPortId != toPortData.toPortId);
                }
              }
              if (fromPortData != null) {
                this.deptPortname = fromPortData.fromPortName;
                this.ExpectedDeparture = fromPortData.fromActualArrivalDate.split("T")[0] //  this.dateConvert(fromPortData.fromPlanArrivalDate);
                this.fromPlanArrivalDate = fromPortData.fromPlanArrivalDate // this.dateConvert(fromPortData.fromPlanArrivalDate);
              }
              if (toPortData != null) {
                this.arrPortName = toPortData.toPortName;
                //  this.ExpectedArrival = toPortData.toActualArrivalDate // this.dateConvert(toPortData.toActualArrivalDate);
                this.toPlanArrivalDate = toPortData.toPToPlanArrivalDate // this.dateConvert(toPortData.toPToPlanArrivalDate);
              }
            }
            else {
              this.trackingData = response.content.voyageRoutesData.filter(x => x.toPortId != response.content.trackingDetail.toPortId);
              var fromPortData = response.content.voyageRoutesData.filter(x => x.fromPortId == response.content.trackingDetail.fromPortId)
              var toPortData = response.content.voyageRoutesData.filter(x => x.toPortId == response.content.trackingDetail.toPortId)
              if (fromPortData != null && fromPortData.length > 0) {
                this.deptPortname = fromPortData[0].fromPortName;
                this.ExpectedDeparture = fromPortData[0].fromActualArrivalDate? fromPortData[0].fromActualArrivalDate.split("T")[0]: null; // this.dateConvert(fromPortData[0].fromPlanArrivalDate);
                this.fromPlanArrivalDate = fromPortData[0].fromPlanArrivalDate // this.dateConvert(fromPortData[0].fromPlanArrivalDate);
              }
              if (toPortData != null && toPortData.length > 0) {
                this.arrPortName = toPortData[0].toPortName;
                // this.ExpectedArrival = toPortData[0].toActualArrivalDate // this.dateConvert(toPortData[0].toActualArrivalDate);
                this.toPlanArrivalDate = toPortData[0].toPlanArrivalDate // this.dateConvert(toPortData[0].toPlanArrivalDate);
              }
            }
          }

          if (response.content.vesselsData != null) {
            this.vesselsname = response.content.vesselsData.data.name;
            this.proBarRemainingValue = this.proBarDefaultValue - this.proBarActualValue;
            if (response.content.vesselsData.data.dest_port != null) {

              this.nextPortCode = response.content.vesselsData.data.dest_port_unlocode;
              this.etaCalc = response.content.vesselsData.data.eta_UTC;
              //this.travelDistanceNm = response.content.vesselsData.nextPort.travelDistanceNm;
              //this.travelTimeH = response.content.vesselsData.nextPort.travelTimeH;


              // this.nextPortETA = response.content.vesselsData.nextPort.etaCalc != null ? this.dateConvert(response.content.vesselsData.nextPort.etaCalc) : null;
              this.nextPortName = response.content.vesselsData.data.dest_port;
            }
            else {
              // if (response.content.vesselsData.voyage != null) {
              //   this.nextPortName = response.content.vesselsData.voyage.destination
              // }
            }

              this.latitude = response.content.vesselsData.data.lat;
              this.longitude = response.content.vesselsData.data.lon;
              this.marker ={ position: { lat: this.latitude, lng: this.longitude }, label: 'A' };
              //this.locationStr = response.content.vesselsData.position.locationStr;
              this.navStatus = response.content.vesselsData.data.navigation_status;
              this.speed = response.content.vesselsData.data.speed;

              //this.currentLocation = response.content.vesselsData.position.locationStr;
              this.currentStatus = response.content.vesselsData.data.navigation_status;
            //if (response.content.vesselsData.voyage != null) {
              this.destination = response.content.vesselsData.data.destination;
              this.draught = response.content.vesselsData.data.current_draught;
              this.VoyageEta = response.content.vesselsData.data.eta_UTC;
              // this.ExpectedArrival = response.content.vesselsData.voyage.eta != null ? this.dateConvert(response.content.vesselsData.voyage.eta) : null;
              // this.delayed = this.calculateDiff(this.ExpectedDeparture, this.ExpectedArrival);
              // this.nextPortETA = (response.content.vesselsData.voyage.eta != null && response.content.vesselsData.voyage.eta != '') ? new Date(response.content.vesselsData.voyage.eta)  : null;
              // this.nextPortETA = (response.content.vesselsData.voyage.eta != null && response.content.vesselsData.voyage.eta != '') ? new Date(response.content.vesselsData.voyage.eta)  : null;
              this.nextPortETA = response.content.vesselsData.data.eta_UTC;
            //  }
          }
          // this.delayed = this.calculateDiff(this.ExpectedDeparture, this.ExpectedArrival);
          if (response.content.trackingNumber != null) {
            this.trackNumber = response.content.trackingNumber;
          }
          if (response.content.trackingId != null) {
            this.trackingId = response.content.trackingId;
          }
          // if (response.content.noOfDays > 0) {
          //   this.delayed = response.content.noOfDays;
          // }

        } else {
          this.spinner.hide();
          this.voyagelist = null;
        }
      });
    }
  }

  getVoyagesByVesselId(event) {
    if (event != null && event.value != null) {
      var vesselsId = event.value.id > 0 ? event.value.id : 0;
      if (vesselsId > 0) {
        this.portService.GetVoyagesByVesselsId(vesselsId).subscribe((response: any) => {
          if (response != null && response.content != null) {
            this.voyagelist = response.content;
          } else {
            this.voyagelist = null;
          }
        });
      }
      else {
        this.voyagelist = this.voyagelistData;
      }
    }
  }


  saveTrackData() {
    if (this.shipId > 0 && this.vesselId > 0) {
      var postData = {
        ShippingLineId: this.shipId,
        VesselsId: this.vesselId,
        VoyageId: this.voyageId,
        FromPortId: this.fromPortId,
        ToPortId: this.toPortId,
        FromDate: this.fromDate,
        UserId: this.userId,
        TrackingNumber: this.trackNumber
      };
      this.spinner.show();
      this.portService.SaveTrackingData(postData).subscribe((response: any) => {
        if (response && response.code == '401') {
          openLoginModal();
        }
        else {
          if (response != null && response.message == 'Daily Limit Exceeded') {
            this.toastr.error('API Limit Exceeded', 'Error')
            this.spinner.hide();
            return;
          }
          if (response != null && response.content != null) {
            if (response.content.vesselsId == null || response.content.vesselsId == 0 || response.content.vesselsId == undefined) {
              if (response.message == 'Vessels MMSI Number is not available') {
                this.toastr.error('This Vessels MMSI Number is not available', 'Error')
                this.spinner.hide();
                return;
              }
            }
            if (response.content.noOfDays > 0) {
              this.delayed = response.content.noOfDays;
            }

            if (response.content.voyageRoutesData != null && response.content.voyageRoutesData.length > 0) {
              this.isFound = true;
              this.proBarActualValue = response.content.voyageRoutesData.length;
              if (this.proBarActualValue < 10) {
                if (this.proBarActualValue <= 4) {
                  this.progressValues = 215;
                }
                else if (this.proBarActualValue < 10 && this.proBarActualValue >= 5) {
                  this.progressValues = 175;
                }
                else if (this.proBarActualValue > 15) {
                  this.progressValues = 90;
                }
              }
              if (response.content.vesselsData != null && response.content.vesselsData.data.dep_port) {
                var count = 1;
                this.lastPortCode = response.content.vesselsData.data.dep_port_unlocode;
                //TODO
               // this.ata = response.content.vesselsData.last_port.ata;
                this.atd = response.content.vesselsData.data.atd_UTC;

                response.content.voyageRoutesData.forEach(element => {
                  if (element != null) {
                    element.fromActualArrivalDate = element.fromActualArrivalDate != null ? this.dateConvert(element.fromActualArrivalDate) : null;
                    element.fromActualDepartureDate = element.fromActualDepartureDate != null ? this.dateConvert(element.fromActualDepartureDate) : null;
                    element.fromPlanArrivalDate = element.fromPlanArrivalDate != null ? this.dateConvert(element.fromPlanArrivalDate) : null;
                    element.toActualArrivalDate = element.toActualArrivalDate != null ? this.dateConvert(element.toActualArrivalDate) : null;
                    element.toPlanArrivalDate = element.toPlanArrivalDate != null ? this.dateConvert(element.toPlanArrivalDate) : null;
                    element.toActualDepartureDate = element.toActualDepartureDate != null ? this.dateConvert(element.toActualDepartureDate) : null;

                    if (count == this.proBarActualValue) {
                      if (response.content.vesselsData != null && response.content.vesselsData.data.dest_port) {
                        var portCode = (element.toPortCode != null && element.toPortCode != '') ? element.toPortCode.replace(/\s/g, "") : '';
                        var vesselsPortCode =  response.content.vesselsData.data.dest_port_unlocode.replace(/\s/g, "");
                        if (vesselsPortCode == portCode) {
                          var etaDate = this.dateConvert(response.content.vesselsData.data.eta_UTC);
                          if (etaDate == element.toPlanArrivalDate) {
                            this.delayed = 0;
                            element.toActualArrivalDate = response.content.vesselsData.data.eta_UTC != null ? this.dateConvert(response.content.vesselsData.data.eta_UTC) : null;
                          }
                          else {
                            element.toActualArrivalDate = response.content.vesselsData.data.eta_UTC != null ? this.dateConvert(response.content.vesselsData.data.eta_UTC) : null;
                          }
                        }
                      }
                    }
                    if (count == 1) {
                      var portCode = element.fromPortCode.replace(/\s/g, "");
                      if (portCode == response.content.vesselsData.data.dep_port_unlocode) {
                        this.positionCount = count;
                      }
                    }
                    var portCode = element.toPortCode.replace(/\s/g, "");
                    if (portCode == response.content.vesselsData.data.dep_port_unlocode) {
                      this.positionCount = count;
                    }
                    else {
                      var destination = response.content.vesselsData.data.destination.replace(/\s/g, "");
                      if (element.toPortName.toLowerCase() == destination.toLowerCase() || destination.toLowerCase().includes(element.toPortName.toLowerCase())) {
                        this.positionCount = count;
                        this.positionCount = this.positionCount - 1;
                      }
                    }
                    count = count + 1;
                  }
                });
                this.ExpectedArrival = response.content.voyageRoutesData[this.proBarActualValue - 1].toActualArrivalDate;
                this.isSource = response.content.voyageRoutesData[0].portDepartureStatus;
              }
              if (response.content.voyageRoutesData) {
                const lengthOfRoutesData = response.content.voyageRoutesData.length
                this.ExpectedArrival = response.content.voyageRoutesData[lengthOfRoutesData - 1].toActualArrivalDate.split("T")[0]
              }
              if (this.isSource == true) {
                this.positionCount = 0;
              }
              var values = 100 / this.proBarActualValue;
              this.progressData = values * this.positionCount;
              var values1 = 100 % this.proBarActualValue;
              if (values1 > 0) {
                var progressNum = this.progressData.toFixed(2);
                this.progressData = parseFloat(progressNum);
                // var DataProgress = progressDataStr.split('.');
                // if(DataProgress.length > 1){
                //   var progressbar = DataProgress[0]+'.'+'50';
                // }
              }

              if (this.voyageId > 0) {
                var length = response.content.voyageRoutesData.length;
                var fromPortData = response.content.voyageRoutesData[0];
                var toPortData = response.content.voyageRoutesData[length - 1];

                if (fromPortData != null && toPortData != null) {
                  var trackData = response.content.voyageRoutesData.filter(x => x.toPortId != fromPortData.toPortId);
                  if (trackData != null && trackData.length > 0) {
                    this.trackingData = trackData.filter(x => x.toPortId != toPortData.toPortId);
                  }
                }
                if (fromPortData != null) {
                  this.deptPortname = fromPortData.fromPortName;
                  this.ExpectedDeparture = fromPortData.fromActualArrivalDate ? fromPortData.fromActualArrivalDate.split("T")[0]: null //  this.dateConvert(fromPortData.fromPlanArrivalDate);
                  this.fromPlanArrivalDate = fromPortData.fromPlanArrivalDate // this.dateConvert(fromPortData.fromPlanArrivalDate);
                }
                if (toPortData != null) {
                  this.arrPortName = toPortData.toPortName;
                  // this.ExpectedArrival = toPortData.toActualArrivalDate // this.dateConvert(toPortData.toActualArrivalDate);
                  this.toPlanArrivalDate = toPortData.toPToPlanArrivalDate // this.dateConvert(toPortData.toPToPlanArrivalDate);
                }
              }
              else {
                this.trackingData = response.content.voyageRoutesData.filter(x => x.toPortId != this.toPortId);
                var fromPortData = response.content.voyageRoutesData.filter(x => x.fromPortId == this.fromPortId)
                var toPortData = response.content.voyageRoutesData.filter(x => x.toPortId == this.toPortId)
                if (fromPortData != null && fromPortData.length > 0) {
                  this.deptPortname = fromPortData[0].fromPortName;
                  this.ExpectedDeparture = fromPortData[0].fromActualArrivalDate? fromPortData[0].fromActualArrivalDate.split("T")[0]: null; // this.dateConvert(fromPortData[0].fromPlanArrivalDate);
                  this.fromPlanArrivalDate = fromPortData[0].fromPlanArrivalDate // this.dateConvert(fromPortData[0].fromPlanArrivalDate);
                }
                if (toPortData != null && toPortData.length > 0) {
                  this.arrPortName = toPortData[0].toPortName;
                  // this.ExpectedArrival = toPortData[0].toActualArrivalDate // this.dateConvert(toPortData[0].toActualArrivalDate);
                  this.toPlanArrivalDate = toPortData[0].toPlanArrivalDate // this.dateConvert(toPortData[0].toPlanArrivalDate);
                }
              }
            }

            if (response.content.vesselsData != null) {
              this.MMSINumber = response.content.vesselsData.data.mmsi;
              this.proBarRemainingValue = this.proBarDefaultValue - this.proBarActualValue;
              if (response.content.vesselsData.data.dest_port) {

                this.nextPortCode = response.content.vesselsData.data.dest_port_unlocode;
                this.etaCalc = response.content.vesselsData.data.eta_UTC;
                //TODO
                //this.travelDistanceNm = response.content.vesselsData.nextPort.travelDistanceNm;
                //this.travelTimeH = response.content.vesselsData.nextPort.travelTimeH;


                this.nextPortName = response.content.vesselsData.data.dest_port;
              }
              else {
                //TODO
                // if (response.content.vesselsData.voyage != null) {
                //   this.nextPortName = response.content.vesselsData.voyage.destination
                // }
              }
                this.latitude = response.content.vesselsData.data.lat;
                this.longitude = response.content.vesselsData.data.lon;
                this.marker ={ position: { lat: this.latitude, lng: this.longitude }, label: 'A' };
                //TODO
                //this.locationStr = response.content.vesselsData.data.locationStr;
                this.navStatus = response.content.vesselsData.data.navigation_status;
                this.speed = response.content.vesselsData.data.speed;
                //TODO
               // this.currentLocation = response.content.vesselsData.position.locationStr;
                this.currentStatus = response.content.vesselsData.data.navigation_status;
                //TODO
              // if (response.content.vesselsData.voyage != null) {
                this.destination = response.content.vesselsData.data.destination;
                this.draught = response.content.vesselsData.data.current_draught;
                this.VoyageEta = response.content.vesselsData.data.eta_UTC;
                this.nextPortETA = response.content.vesselsData.data.eta_UTC;
              // }
            }
            if (response.content.trackingNumber != null) {
              this.trackNumber = response.content.trackingNumber;
            }
            if (response.content.trackingId != null) {
              this.trackingId = response.content.trackingId;
            }
            this.spinner.hide();
          }
        }
        this.spinner.hide();
      },(error=>{
         this.toastr.error(error.error.message, 'Error')
            this.spinner.hide();
            return;
      }));
    }
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    //return [date.getFullYear(), mnth, day].join("-");
    return [day, mnth, date.getFullYear()].join("-");
  }

  dateConvertnew(str) {
    if (str != null && str != '') {
      var dateData = str.split('-');
      if (dateData.length > 0) {
        var date = dateData[2] + '-' + dateData[1] + '-' + dateData[0];
      }
    }
    return date
  }


  onTrack() {
    if (this.trackingForm.invalid) {
      if (this.trackingForm.controls.shippingLine.invalid == true) {
        this.toastr.error('Please select ShippingLine.', 'Oops !');
        return;
      }
      if (this.trackingForm.controls.vessel.invalid == true) {
        this.toastr.error('Please select Vessels.', 'Oops !');
        return;
      }
      if (this.trackingForm.controls.Voyage.invalid == true) {
        this.toastr.error('Please select Voyages.', 'Oops !');
        return;
      }
    }
    else {
      if ((this.trackingForm.controls.shippingLine.value as any)?.shippingLineId > 0 && (this.trackingForm.controls.vessel.value as any)?.id > 0 && (this.trackingForm.controls.Voyage.value as any)?.id > 0) {
        this.shipId = (this.trackingForm.controls.shippingLine.value as any)?.shippingLineId;
        this.vesselId = (this.trackingForm.controls.vessel.value as any)?.id;
        this.voyageId = (this.trackingForm.controls.Voyage.value as any)?.id;
        this.saveTrackData();
      }
    }
  }

  saveTracking() {
    if (this.trackNumber != null && this.trackNumber != '') {

      var Data = {
        ShippingLineId: this.shipId,
        VesselsId: this.vesselId,
        VoyageId: this.voyageId,
        FromPortId: this.fromPortId,
        ToPortId: this.toPortId,
        FromDate: this.fromDate,
        UserId: this.userId,
        TrackingNumber: this.trackNumber,
        TrackingId: this.trackingId,
        ExpectedDeparture: this.dateConvertnew(this.ExpectedDeparture),
        ExpectedArrival: this.dateConvertnew(this.ExpectedArrival),
        FromPlanArrivalDate: this.dateConvertnew(this.fromPlanArrivalDate),
        ToPlanArrivalDate: this.dateConvertnew(this.toPlanArrivalDate),
        MMSINumber: this.MMSINumber.toString()
      }

      // var Data = {
      //   ShippingLineId: this.shipId,
      //   VesselsId: this.vesselId,
      //   VoyageId: this.voyageId,
      //   FromPortId: this.fromPortId,
      //   ToPortId: this.toPortId,
      //   FromDate: this.fromDate,
      //   UserId: this.userId,
      //   TrackingNumber: this.trackNumber,
      //   TrackingId: this.trackingId,
      //   Destination: this.destination,
      //   Draught: this.draught,
      //   VoyageEta: this.VoyageEta,
      //   Latitude: this.latitude,
      //   Longitude: this.longitude,
      //   LocationStr: this.locationStr,
      //   NavStatus: this.navStatus,
      //   Speed: this.speed,
      //   NextPortCode: this.nextPortCode,
      //   EtaCalc: this.etaCalc,
      //   TravelDistanceNm: this.travelDistanceNm,
      //   TravelTimeH: this.travelTimeH,
      //   LastPortCode: this.lastPortCode,
      //   Lastata: this.ata,
      //   Lastatd: this.atd
      // }
      this.spinner.show();
      this.portService.updateTrackingData(Data).subscribe((response: any) => {
        if (response != null && response.isSuccess == true) {
          this.toastr.info(response.message, 'Info')
          this.spinner.hide();
          this.router.navigate(['/trackingvoyage']);
        }
        this.spinner.hide();
      });
    }
  }

  calculateDiff(fromDate, toDate) {
    var date1: any = new Date(fromDate);
    var date2: any = new Date(toDate);
    var diffDays: any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  // Get Current Location Coordinates
  // private setCurrentLocation(latitude, longitude) {
  //   if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       this.latitude = position.coords.latitude;
  //       this.longitude = position.coords.longitude;
  //        this.zoom = 15;
  //     });
  //   }
  // }
}
